module.exports = "https://static.wshopon.com/static/v1.3.2-rc.1/store/images/default-Lastsales.c88e3c.png";